import React from "react";

import PlanUpgrade from "../PlanUpgrade";

const Notes = props => (
  <div className="context-activity animated fadeinright">
    <div className="note-header-upgrade">
      <span className="note-right-pane-title">Notes</span>
    </div>

    <div className="note-upgrade-container">
      <img
        src="https://d34fwl795uvawg.cloudfront.net/images/upgrade-popup/notes.png"
        className="notes-upload-image"
        alt="attachment"
      />
      <div className="note-upgrade-txt">
        {props.isSharedDocument
          ? "Contact the document sender to enable attachments. Have threaded conversations and collaborate with ease by adding notes."
          : "To add notes and collaborate with recipients, upgrade to premium plan"}
      </div>
      <PlanUpgrade
        isSharedDocument={props.isSharedDocument}
        type={props.featureName}
      />
    </div>
  </div>
);

export default Notes;
